// src/services/administrativo/ConfigDFeService.js
import api, { deleteData, fetchData, postData, putData } from '../Api';

export const listarConfigDFe = () => fetchData('/ConfigDFe');
export const adicionarConfigDFe = (config) => postData('/ConfigDFe', config);
export const alterarConfigDFe = (config) => putData('/ConfigDFe', config);
export const excluirConfigDFe = (id) => deleteData('/ConfigDFe', { configDFeId: id });
export const salvarCertificadoConfigDFe = async (configDFeId, arquivo, senha) => {
    const formData = new FormData();
    formData.append('configDFeId', configDFeId);
    formData.append('senha', senha);
    formData.append('certificado', arquivo);

    const response = await api.post('/ConfigDFe/Certificado', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });

    return response.data;
};
